/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindTagsQueryResponse } from "../types/FindTags.ts"

export const findTagsQueryKey = () => [{ url: "/v1/tags" }] as const

export type FindTagsQueryKey = ReturnType<typeof findTagsQueryKey>

/**
 * @summary Find all tags
 * {@link /v1/tags}
 */
export async function findTags(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTagsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/tags`, ...requestConfig })
  return res
}

export function findTagsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findTagsQueryKey()
  return queryOptions<
    ResponseConfig<FindTagsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTagsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findTags(config)
    },
  })
}

/**
 * @summary Find all tags
 * {@link /v1/tags}
 */
export function useFindTags<
  TData = ResponseConfig<FindTagsQueryResponse>,
  TQueryData = ResponseConfig<FindTagsQueryResponse>,
  TQueryKey extends QueryKey = FindTagsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTagsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findTagsQueryKey()

  const query = useQuery(
    {
      ...findTagsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
